document.addEventListener('alpine:init', () => {
  const _UTILS = {
    OnMutate(targetNodes, callback) {
      var observer = new MutationObserver(callback);
  
      // Notify me of everything!
      var observerConfig = {
        attributes: true, 
        childList: true, 
        characterData: true
      };
  
      targetNodes.forEach((node) => {
        // console.log(node)
        observer.observe(node, observerConfig);
      });
    },
    ConvertStringToHTML(str) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(str, 'text/html');
      return doc.body;
    },
    ObserveIntersection(node, config, callback) {
      if (!node) callback(null);
      let observer = new IntersectionObserver((entries) => {
        callback(entries);
      }, config);
      
      observer.observe(node, config);  
      return observer;
    }    
  };

  Alpine.data('ProductOptions', () => ({
    product: {},
    selected_variant: {},
    flags: {
      product_soldout: false,
      is_b2b: false
    },
    init() {
      this.InitSelf();
      this.InitWatchers();
      this.InitEventHandlers();
    },
    InitSelf() {
      let am = this;
      let product = JSON.parse(am.$el.dataset.jsonProduct);
      let inv_policy = JSON.parse(am.$el.dataset.jsonInvPolicy);
      let inv_qty = JSON.parse(am.$el.dataset.jsonInvQty);
      product.variants.forEach((v, index) => {
        v.inventory_policy = inv_policy[index];
        v.inventory_qty = inv_qty[index];
      });

      am.product = {...product};
      am.selected_variant = JSON.parse(am.$el.dataset.jsonSelectedVariant);
      window.all_variants = [];
      window.all_variants = [...window.all_variants, ...am.product.variants];

      am.UpdateFlags();
    },
    InitWatchers() {
      let am = this;
      am.$watch('product', () => am.UpdateFlags.bind(am));
    },
    InitEventHandlers() {
      let am = this;
      document.addEventListener('variant:change', (e) => {
        let _variant = am.product.variants.find(v => v.id == e.detail.variant.id);
        am.selected_variant = _variant;
      });
    },
    UpdateFlags() {
      let am = this;
      window.is_b2b = am.flags.is_b2b = am.$el.dataset.isb2b == 'true';

      let available_variants = am.product.variants.filter(v => v.available);
      if (!am.flags.is_b2b) {
        available_variants = am.product.variants.filter(v => v.inventory_qty > 0);
      }
      // console.log(available_variants)
      am.flags.product_soldout = available_variants.length == 0;
    }
  }));

  Alpine.data('CartItemsCount', () => ({
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      _UTILS.OnMutate([this.$el], this.CheckPreorderItems.bind(this));
      _UTILS.OnMutate([document.querySelector('[data-sidebar-drawer-content]')], this.CheckPreorderItems.bind(this));
    },
    async CheckPreorderItems() {
      let cart = await fetch('/cart.js').then(res => res.json());
      let section_id = 'cart-preorder-items';
      let items_res = await fetch(`/cart?sections=${section_id}`).then(res => res.json());
      let $items_res = _UTILS.ConvertStringToHTML(items_res[section_id]);
      let preorder_items = JSON.parse($items_res.querySelector('[data-preorder_items]').dataset.preorder_items);
      let soldout_items = JSON.parse($items_res.querySelector('[data-soldout_items]').dataset.soldout_items);
      // console.log({preorder_items, soldout_items});

      // DTC check
      // If DTC && Item is allowed to continue && inventory <= 0, show Soldout Modal
      if (!window.is_b2b) {
        let $cart_modal = document.querySelector('cart-modal');
        if (!$cart_modal) return;

        let soldout_items = cart.items.filter((item) => {
          return preorder_items.indexOf(item.variant_id.toString()) !== -1;
        });

        if (soldout_items.length > 0) {
          // console.log('Show Soldout Modal for ', soldout_items);
          // $cart_modal.dispatchEvent(new CustomEvent('show:cart-modal-soldout-items', {
          //   detail: {soldout_items}
          // }));  

          // console.log(document.querySelectorAll('button-checkout'));
          document.querySelectorAll('button-checkout').forEach(($button) => {
            $button.classList.add('checkout-disabled');
            $button.dataset.soldout_items = JSON.stringify(soldout_items);
          });

          document.querySelectorAll('.additional-checkout-buttons').forEach(($buttons) => {
            $buttons.classList.add('hidden');
          });
        }
        else {
          document.querySelectorAll('button-checkout').forEach(($button) => {
            $button.classList.remove('checkout-disabled');
            $button.removeAttribute('data-soldout_items');
          });

          document.querySelectorAll('.additional-checkout-buttons').forEach(($buttons) => {
            $buttons.classList.remove('hidden');
          });
        }
      }

      // B2B check
      // If B2B && Item is allowed to continue && inventory <= 0, && no preorder property. ADD preorder property
      if (window.is_b2b) {
        let preorder_lineitems = cart.items.filter((item) => {
          return preorder_items.indexOf(item.variant_id.toString()) !== -1;
        });

        let items_without_prop = preorder_lineitems.filter(item => !item.properties['Status']);
        if (items_without_prop.length) {
          (async() => {
            let px = items_without_prop.map(item => {
              return fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(
                  {
                    id: item.key,
                    properties: {...item.properties, ...{ 'Status': 'PREORDER' }}
                  }                
                )
              })
              .then(response => response.json())
              .then(data => console.log(data));                                  
            });
            Promise.all(px);
          })();
        }
      }
    }
  }));

  Alpine.data('CartModal', () => ({
    flags: {
      open: false,
      allow_close: true
    },
    soldout_items: [],
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      this.$el.addEventListener('show:cart-modal-soldout-items', (e) => {
        // console.log(e.detail);
        this.soldout_items = [...e.detail.soldout_items];
        this.flags.open = true;
      });
    },
    e_OpenModal() {
      this.flags.open = true;
    },
    e_CloseModal() {
      this.flags.open = false;
    },
    async e_RemoveItemsAndCheckout() {
      let updates = {};
      this.soldout_items.forEach((item) => {
        updates[item.key] = 0;
      });

      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });
      window.location.href = '/checkout';
    }
  }));

  Alpine.data('LoadMoreProducts', () => ({
    page: 1,
    page_count: 1,
    products_count: 0,
    product_limit: 0,
    delay: 2500,
    flags: {
      loading: false,
      isLastPage: false
    },
    init() {
      let am = this;
      am.products_count = parseInt(am.$el.dataset.products_count);
      am.product_limit = parseInt(am.$el.dataset.product_limit);
      am.page_count = Math.ceil(am.products_count / am.product_limit);

      let $observe_state = am.$el.querySelector('.pagination');
      _UTILS.ObserveIntersection($observe_state, {}, (entries) => {
        let entry = entries[0];
        // console.log(entry)
        if (entry.isIntersecting)  {
          if (am.flags.loading) return;
          if (am.flags.isLastPage) return;

          // console.log(e);
          Alpine.throttle(() => {
            am.flags.loading = true;
            setTimeout(am.LoadMore.bind(am), am.delay);
          }, 500)();
        }
      });
    },

    LoadMore() {
      am = this;

      am.page += 1;
      am.flags.isLastPage = am.page >= am.page_count;

      (async () => {
        let section_id = am.$el.dataset.sectionId;
        let url  = `${ window.location.pathname }${ window.location.search }${ window.location.search.indexOf('?') == -1 ? '?' : '&' }page=${ am.page }&sections=${ section_id }`;
        console.log(url);
        let res = await fetch(url).then((res => res.json()));
        // console.log(res);
        let $section = _UTILS.ConvertStringToHTML(res[section_id]);
        let $products = [...$section.querySelectorAll('.product')];
        // console.log($section, $products);

        $products.forEach(($product) => {
          $product.querySelectorAll('img').forEach(($img) => {
            $img.removeAttribute('data-rimg');
            $img.removeAttribute('data-rimg-template');
            $img.removeAttribute('srcset');
            // console.log($img)
          });
          am.$el.querySelector('.product-list').insertAdjacentElement('beforeend', $product);
        });
        document.dispatchEvent(new Event('pagination:products-loaded'));

        am.$el.dataset.page = am.page;
        am.flags.loading = false;
      })();
    }
  }));
});

if (!customElements.get('button-checkout')) {
  customElements.define('button-checkout', class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let $button = this.querySelector('button');
      $button.addEventListener('click', (e) => {
        if (this.classList.contains('checkout-disabled')) { 
          e.preventDefault();
          let $cart_modal = document.querySelector('cart-modal');  
          let soldout_items = JSON.parse(this.dataset.soldout_items);
          $cart_modal.dispatchEvent(new CustomEvent('show:cart-modal-soldout-items', {
            detail: {soldout_items}
          }));  
          return;
        }
      });
    }
  });
}